import { useEffect, useRef, useState } from 'react';

const SessionMessages = (maxHeightPx) => {
  const [messages, setMessages] = useState([]);
  const messagesContainerRef = useRef(null);
  const sessionExpiredShownRef = useRef(false);

  useEffect(() => {
    const container = messagesContainerRef.current;
    if (!container) return;
    if (container.scrollHeight <= maxHeightPx) return;
    setMessages((prev) => (prev.length > 0 ? prev.slice(1) : prev));
  }, [messages, maxHeightPx]);

  const closeMessage = (id) => {
    setMessages((prev) => prev.filter((msg) => msg.id !== id));
  };

  const updateMessage = (message, type, uniqueKey = null) => {
    setMessages((prev) => {
      if (uniqueKey === 'access-changed') {
        const withoutSessionExpired = prev.filter((msg) => msg.uniqueKey !== 'session-expired');
        if (withoutSessionExpired.some((msg) => msg.uniqueKey === uniqueKey)) return withoutSessionExpired;
        return [...withoutSessionExpired, {
          id: Date.now() + Math.random(),
          text: message,
          type,
          uniqueKey,
        }];
      }
      if (uniqueKey && prev.some((msg) => msg.uniqueKey === uniqueKey)) return prev;
      return [...prev, {
        id: Date.now() + Math.random(),
        text: message,
        type,
        uniqueKey,
      }];
    });
  };

  const resetSessionExpiredFlag = () => {
    sessionExpiredShownRef.current = false;
  };

  const showSessionExpiredOnce = () => {
    if (sessionExpiredShownRef.current) return;
    sessionExpiredShownRef.current = true;
    setMessages((prev) => {
      if (prev.some((msg) => msg.uniqueKey === 'access-changed')) return prev;
      if (prev.some((msg) => msg.uniqueKey === 'session-expired')) return prev;
      return [...prev, {
        id: Date.now() + Math.random(),
        text: 'La sesion expiro, vuelva a ingresar nuevamente',
        type: 'error',
        uniqueKey: 'session-expired',
      }];
    });
  };

  return {
    messages,
    messagesContainerRef,
    closeMessage,
    updateMessage,
    resetSessionExpiredFlag,
    showSessionExpiredOnce,
  };
};

export default SessionMessages;
